export type Layout = 'book' | 'booklayout' | 'minimal-book' | 'uploader';

// De frontend-layout komt uit de URL (?layout=...), zie App.tsx. Zonder (bekende) waarde is het
// de standaard uploader.
export const getLayout = (): Layout => {
  const value = new URLSearchParams(window.location.search).get('layout');
  if (value === 'book' || value === 'booklayout' || value === 'minimal-book') return value;
  return 'uploader';
};
